import { SYSTEM_BET_COMBINATIONS_TEXT_KEYS } from '~/components/sportsbook/lobby/components/bet/sportsbook-bet-text-keys';

enum BetslipTextKeys {
	RECEIPTS_BETS_PLACED_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_BETS_PLACED_TITLE',
	RECEIPTS_BETS_REJECTED_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_BETS_REJECTED_TITLE',
	RECEIPTS_BETS_UNKNOWN_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_BETS_UNKNOWN_TITLE',
	RECEIPTS_SINGLE_BETS_PLACED_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_SINGLE_BETS_PLACED_TITLE',
	RECEIPTS_SINGLE_BETS_REJECTED_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_SINGLE_BETS_REJECTED_TITLE',
	RECEIPTS_SINGLE_BETS_UNKNOWN_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_SINGLE_BETS_UNKNOWN_TITLE',
	RECEIPTS_COMBO_BETS_PLACED_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_COMBO_BETS_PLACED_TITLE',
	RECEIPTS_COMBO_BETS_REJECTED_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_COMBO_BETS_REJECTED_TITLE',
	RECEIPTS_COMBO_BETS_UNKNOWN_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_COMBO_BETS_UNKNOWN_TITLE',
	RECEIPTS_SYSTEM_BETS_PLACED_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_SYSTEM_BETS_PLACED_TITLE',
	RECEIPTS_SYSTEM_BETS_REJECTED_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_SYSTEM_BETS_REJECTED_TITLE',
	RECEIPTS_SYSTEM_BETS_UNKNOWN_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_SYSTEM_BETS_UNKNOWN_TITLE',
	RECEIPTS_BETS_PLACING_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_BETS_PLACING_TITLE',
	RECEIPTS_BETS_REVIEW_TITLE = 'SPORTSBOOK_BETSLIP_RECEIPTS_BETS_REVIEW_TITLE',
	RECEIPTS_FOOTER_STAKE_LABEL = 'SPORTSBOOK_BETSLIP_RECEIPTS_FOOTER_STAKE_LABEL',
	RECEIPTS_FOOTER_WINS_LABEL = 'SPORTSBOOK_BETSLIP_RECEIPTS_FOOTER_WINS_LABEL',
	FOOTER_STAKE_TITLE_AMOUNT = 'SPORTSBOOK_BETSLIP_FOOTER_STAKE_TITLE_AMOUNT',
	SPORTSBOOK_BETSLIP_FOOTER_TOTAL_ODDS = 'SPORTSBOOK_BETSLIP_FOOTER_TOTAL_ODDS',
	SPORTSBOOK_BETSLIP_ODDS = 'SPORTSBOOK_BETSLIP_ODDS',
	SPORTSBOOK_BETSLIP_BONUS_APPLIED_LABEL = 'SPORTSBOOK_BETSLIP_BONUS_APPLIED_LABEL',
	SPORTSBOOK_BETSLIP_SELECTIONS_LABEL = 'SPORTSBOOK_BETSLIP_SELECTIONS_LABEL',
	FOOTER_NO_STAKE_TITLE = 'SPORTSBOOK_BETSLIP_FOOTER_NO_STAKE_TITLE',
	FOOTER_PLACE_BET_BUTTON_LABEL = 'SPORTSBOOK_BETSLIP_FOOTER_PLACE_BET_BUTTON_LABEL',
	FOOTER_PLACE_COMBO_LABEL = 'SPORTSBOOK_BETSLIP_FOOTER_PLACE_COMBO_LABEL',
	POSSIBLE_WIN_LABEL = 'SPORTSBOOK_BETSLIP_POSSIBLE_WIN_LABEL',
	WIN_LABEL = 'SPORTSBOOK_BETSLIP_WIN_LABEL',
	STAKE_INPUT_LABEL = 'SPORTSBOOK_BETSLIP_STAKE_INPUT_LABEL',
	TITLE = 'SPORTSBOOK_BETSLIP_TITLE',
	UNAUTHORIZED_USER_MESSAGE = 'SPORTSBOOK_BETSLIP_UNAUTHORIZED_USER_MESSAGE',
	UNAUTHORIZED_USER_LINK_TO_LOGIN = 'SPORTSBOOK_BETSLIP_UNAUTHORIZED_USER_LINK_TO_LOGIN',
	USER_BALANCE_TOO_LOW_MESSAGE = 'SPORTSBOOK_BETSLIP_USER_BALANCE_TOO_LOW_MESSAGE',
	USER_BALANCE_TOO_LOW_LINK = 'SPORTSBOOK_BETSLIP_USER_BALANCE_TOO_LOW_LINK',
	BALANCE_TOO_LOW_MESSAGE = 'SPORTSBOOK_BETSLIP_BALANCE_TOO_LOW_MESSAGE',
	PRODUCT_BALANCE_TOO_LOW_MESSAGE = 'SPORTSBOOK_BETSLIP_PRODUCT_BALANCE_TOO_LOW_MESSAGE',
	DEPOSIT_BUTTON_TEXT = 'SPORTSBOOK_BETSLIP_DEPOSIT_BUTTON_TEXT',
	QUICK_DEPOSIT_BUTTON_TEXT = 'SPORTSBOOK_BETSLIP_QUICK_DEPOSIT_BUTTON_TEXT',
	COMBOBET_NOT_COMBINABLE_GROUP_MESSAGE = 'SPORTSBOOK_BETSLIP_COMBOBET_NOT_COMBINABLE_GROUP_MESSAGE',
	BET_HAS_UPDATED_LABEL = 'SPORTSBOOK_BETSLIP_BET_HAS_UPDATED_LABEL',
	ACCEPT_BET_UPDATES_BUTTON = 'SPORTSBOOK_BETSLIP_ACCEPT_BET_UPDATES_BUTTON',
	ODDS_UNAVAILABLE_LABEL = 'SPORTSBOOK_BETSLIP_ODDS_UNAVAILABLE_LABEL',
	ADD_STAKE_LABEL = 'SPORTSBOOK_BETSLIP_ADD_STAKE_LABEL',
	RECEIPT_STAKE_LABEL = 'SPORTSBOOK_BETSLIP_RECEIPT_STAKE_LABEL',
	RECEIPT_POSSIBLE_WIN_LABEL = 'SPORTSBOOK_BETSLIP_RECEIPT_POSSIBLE_WIN_LABEL',
	RECEIPT_BET_COULDNT_BE_PLACED_LABEL = 'SPORTSBOOK_BETSLIP_RECEIPT_BET_COULDNT_BE_PLACED_LABEL',
	COMBO_LABEL = 'SPORTSBOOK_BETSLIP_COMBO_LABEL',
	CLEAR_BETSLIP_LABEL = 'SPORTSBOOK_BETSLIP_CLEAR_BETSLIP_LABEL',
	RECEIPTS_MY_BETS_LABEL = 'SPORTSBOOK_BETSLIP_RECEIPTS_MY_BETS_LABEL',
	RECEIPTS_FOOTER_BUTTON_LABEL = 'SPORTSBOOK_BETSLIP_RECEIPTS_FOOTER_BUTTON_LABEL',
	RECEIPT_COMBO_BET_CAPTION = 'SPORTSBOOK_BETSLIP_RECEIPT_COMBO_BET_CAPTION',
	FOOTER_PLACE_BUTTON_LABEL = 'SPORTSBOOK_BETSLIP_FOOTER_PLACE_BUTTON_LABEL',
	FOOTER_BETS_BUTTON_LABEL = 'SPORTSBOOK_BETSLIP_FOOTER_BETS_BUTTON_LABEL',
	NO_STAKE_ERROR_LABEL = 'SPORTSBOOK_BETSLIP_NO_STAKE_ERROR_LABEL',
	KEEP_SELECTIONS_LABEL = 'SPORTSBOOK_BETSLIP_KEEP_SELECTIONS_LABEL',
	MAX_REPEATED_BETS_REACHED = 'SPORTSBOOK_BETSLIP_MAX_REPEATED_BETS_REACHED',
	MAX_WIN_TOO_HIGH = 'SPORTSBOOK_BETSLIP_MAX_WIN_TOO_HIGH',
	STAKE_TOO_HIGH = 'SPORTSBOOK_BETSLIP_STAKE_TOO_HIGH',
	EVENT_LIMIT_EXCEEDED = 'SPORTSBOOK_BETSLIP_EVENT_LIMIT_EXCEEDED',
	MARKET_LIMIT_EXCEEDED = 'SPORTSBOOK_BETSLIP_MARKET_LIMIT_EXCEEDED',
	MARKET_LOSS_LIMIT_EXCEEDED = 'SPORTSBOOK_BETSLIP_MARKET_LOSS_LIMIT_EXCEEDED',
	SELECTION_LIMIT_EXCEEDED = 'SPORTSBOOK_BETSLIP_SELECTION_LIMIT_EXCEEDED',
	BET_UNAVAILABLE = 'SPORTSBOOK_BETSLIP_BET_UNAVAILABLE',
	MAX_BET_REACED = 'SPORTSBOOK_BETSLIP_MAX_BET_REACED',
	LIVE_BETTING_NOT_POSSIBLE = 'SPORTSBOOK_BETSLIP_LIVE_BETTING_NOT_POSSIBLE',
	GENERAL_ERROR = 'SPORTSBOOK_BETSLIP_GENERAL_ERROR',
	WAIT_ONE_MINUTE_AND_TRY_AGAIN = 'SPORTSBOOK_BETSLIP_WAIT_ONE_MINUTE_AND_TRY_AGAIN',
	NOT_A_POSSIBLE_COMBO = 'SPORTSBOOK_BETSLIP_NOT_A_POSSIBLE_COMBO',
	TOO_LOW_BALANCE = 'SPORTSBOOK_BETSLIP_TOO_LOW_BALANCE',
	ODDS_UPDATED = 'SPORTSBOOK_BETSLIP_ODDS_UPDATED',
	STAKE_HIGHER_THAN_WIN = 'SPORTSBOOK_BETSLIP_STAKE_HIGHER_THAN_WIN',
	ODDS_UNAVAILABLE = 'SPORTSBOOK_BETSLIP_ODDS_UNAVAILABLE',
	BET_SUSPENDED = 'SPORTSBOOK_BETSLIP_BET_SUSPENDED',
	COMBO_NOT_POSSIBLE = 'SPORTSBOOK_BETSLIP_COMBO_NOT_POSSIBLE',
	NOT_ENOUGH_FUNDS = 'SPORTSBOOK_BETSLIP_NOT_ENOUGH_FUNDS',
	PLAYER_NEEDS_MORE_VERIFICATION_TO_PLACE_BET = 'SPORTSBOOK_PLAYER_NEEDS_MORE_VERIFICATION_TO_PLACE_BET',
	PLAYER_NOT_FULLY_VERIFIED = 'SPORTSBOOK_BETSLIP_PLAYER_NOT_FULLY_VERIFIED',
	GENERAL_ERROR_TRY_AGAIN = 'SPORTSBOOK_BETSLIP_GENERAL_ERROR_TRY_AGAIN',
	STAKE_IS_TOO_LOW = 'SPORTSBOOK_BETSLIP_STAKE_IS_TOO_LOW',
	MINIMUM_STAKE_LABEL = 'SPORTSBOOK_BETSLIP_MINIMUM_STAKE_LABEL',
	INVALID_BONUS = 'SPORTSBOOK_BETSLIP_INVALID_BONUS',
	INVALID_BONUS_STAKE_TOO_LOW = 'SPORTSBOOK_BETSLIP_INVALID_BONUS_STAKE_TOO_LOW',
	INVALID_BONUS_STAKE_TOO_HIGH = 'SPORTSBOOK_BETSLIP_INVALID_BONUS_STAKE_TOO_HIGH',
	ITEM_COUNT_TOO_LOW = 'SPORTSBOOK_BETSLIP_ITEM_COUNT_TOO_LOW',
	ITEM_COUNT_TOO_HIGH = 'SPORTSBOOK_BETSLIP_ITEM_COUNT_TOO_HIGH',
	ODDS_TOO_LOW = 'SPORTSBOOK_BETSLIP_ODDS_TOO_LOW',
	ODDS_TOO_HIGH = 'SPORTSBOOK_BETSLIP_ODDS_TOO_HIGH',
	STAKE_LIMIT_REACHED = 'SPORTSBOOK_BETSLIP_STAKE_LIMIT_REACHED',
	LOSS_LIMIT_REACHED = 'SPORTSBOOK_BETSLIP_LOSS_LIMIT_REACHED',
	AGE_NOT_VERIFIED = 'SPORTSBOOK_BETSLIP_AGE_NOT_VERIFIED',
	LUGAS_ACTIVE_ON_OTHER_OPERATOR = 'SPORTSBOOK_BETSLIP_LUGAS_ACTIVE_ON_OTHER_OPERATOR',
	LUGAS_ON_SITE_COOLOFF = 'SPORTSBOOK_BETSLIP_LUGAS_ON_SITE_COOLOFF',
	MAXIMUM_RETURNS_EXCEEDED = 'SPORTSBOOK_BETSLIP_MAXIMUM_GAIN_EXCEEDED',
	LUGAS_ACTIVE_ON_CURRENT_OPERATOR = 'SPORTSBOOK_BETSLIP_LUGAS_ACTIVE_ON_CURRENT_OPERATOR',
	SPORTSBOOK_PRODUCT_BLOCKED = 'SPORTSBOOK_BETSLIP_SPORTSBOOK_PRODUCT_BLOCKED',
	PLAYER_STATUS_GAMEPLAY_BLOCKED = 'SPORTSBOOK_BETSLIP_PLAYER_STATUS_GAMEPLAY_BLOCKED',
	BALANCE_LIMIT_EXCEEDED = 'SPORTSBOOK_BETSLIP_BALANCE_LIMIT_EXCEEDED',
	SEAMLESS_ERROR_LIMIT_DAY_BET_EXEEDED = 'SPORTSBOOK_BETSLIP_SEAMLESS_ERROR_LIMIT_DAY_BET_EXEEDED',
	SEAMLESS_ERROR_LIMIT_WEEK_BET_EXEEDED = 'SPORTSBOOK_BETSLIP_SEAMLESS_ERROR_LIMIT_WEEK_BET_EXEEDED',
	SEAMLESS_ERROR_LIMIT_MONTH_BET_EXEEDED = 'SPORTSBOOK_BETSLIP_SEAMLESS_ERROR_LIMIT_MONTH_BET_EXEEDED',
	SEAMLESS_ERROR_DAILY_TIME_LIMIT_EXEEDED = 'SPORTSBOOK_BETSLIP_SEAMLESS_ERROR_DAILY_TIME_LIMIT_EXEEDED',
	SEAMLESS_ERROR_WEEKLY_TIME_LIMIT_EXEEDED = 'SPORTSBOOK_BETSLIP_SEAMLESS_ERROR_WEEKLY_TIME_LIMIT_EXEEDED',
	SEAMLESS_ERROR_MONTHLY_TIME_LIMIT_EXEEDED = 'SPORTSBOOK_BETSLIP_SEAMLESS_ERROR_MONTHLY_TIME_LIMIT_EXEEDED',
	SEAMLESS_ERROR_RC_COOLOFF = 'SPORTSBOOK_BETSLIP_SEAMLESS_ERROR_RC_COOLOFF',
	SEAMLESS_ERROR_PRODUCT_SWITCH_NEEDED = 'SPORTSBOOK_BETSLIP_SEAMLESS_ERROR_PRODUCT_SWITCH_NEEDED',
	SEAMLESS_ERROR_MISSING_TIME_LIMIT = 'SPORTSBOOK_BETSLIP_SEAMLESS_ERROR_MISSING_TIME_LIMIT',
	NEW_OFFER_PLACE = 'SPORTSBOOK_BETSLIP_NEW_OFFER_PLACE',
	NEW_OFFER_REJECT = 'SPORTSBOOK_BETSLIP_NEW_OFFER_REJECT',
	NEW_OFFER_TITLE = 'SPORTSBOOK_BETSLIP_NEW_OFFER_TITLE',
	NEW_OFFER_DESCRIPTION = 'SPORTSBOOK_BETSLIP_NEW_OFFER_DESCRIPTION',
	NEW_OFFER_MESSAGE = 'SPORTSBOOK_BETSLIP_NEW_OFFER_MESSAGE',
	NEW_OFFER_MESSAGE_CHECKBOX_LABEL = 'SPORTSBOOK_BETSLIP_NEW_OFFER_MESSAGE_CHECKBOX_LABEL',
	NEW_OFFER_REJECTED_TITLE = 'SPORTSBOOK_BETSLIP_NEW_OFFER_REJECTED_TITLE',
	NEW_OFFER_REJECTED_DESCRIPTION = 'SPORTSBOOK_BETSLIP_NEW_OFFER_REJECTED_DESCRIPTION',
	BET_UNKNOWN_TITLE = 'SPORTSBOOK_BETSLIP_BET_UNKNOWN_TITLE',
	BET_UNKNOWN_DESCRIPTION = 'SPORTSBOOK_BETSLIP_BET_UNKNOWN_DESCRIPTION',
	SINGLE_BETS = 'SPORTSBOOK_BETSLIP_ACTION_HEADER_LABEL_SINGLES',
	TAB_SINGLE_BETS = 'SPORTSBOOK_BETSLIP_TAB_SINGLE_BETS',
	TAB_COMBO_BETS = 'SPORTSBOOK_BETSLIP_TAB_COMBO_BETS',
	TAB_SYSTEM_BETS = 'SPORTSBOOK_BETSLIP_TAB_SYSTEM_BETS',
	PLACEMENT_NEW_OFFER_MESSAGE_LABEL = 'SPORTSBOOK_BETSLIP_PLACEMENT_NEW_OFFER_MESSAGE_LABEL',
	FREE_BET_SELECT_DEFAULT_LABEL = 'SPORTSBOOK_BETSLIP_FREE_BET_SELECT_DEFAULT_LABEL',
	FREE_BET_STAKE_TITLE = 'SPORTSBOOK_BETSLIP_FREE_BET_STAKE_TITLE',
	RISK_FREE_BET_STAKE_TITLE = 'SPORTSBOOK_BETSLIP_RISK_FREE_BET_STAKE_TITLE',
	BET_DECLINED_BY_CLIENT_DECISION = 'SPORTSBOOK_BETSLIP_BET_DECLINED_BY_CLIENT_DECISION',
	SETTINGS_HEADER_TITLE = 'SPORTSBOOK_BETSLIP_SETTINGS_HEADER_TITLE',
	SETTINGS_AUTO_ACCEPT_MODE_TITLE = 'SPORTSBOOK_BETSLIP_SETTINGS_AUTO_ACCEPT_MODE_TITLE',
	SETTINGS_AUTO_ACCEPT_MODE_ACCEPT_ALL_TITLE = 'SPORTSBOOK_BETSLIP_SETTINGS_AUTO_ACCEPT_MODE_ACCEPT_ALL_TITLE',
	SETTINGS_AUTO_ACCEPT_MODE_ACCEPT_HIGHER_TITLE = 'SPORTSBOOK_BETSLIP_SETTINGS_AUTO_ACCEPT_MODE_ACCEPT_HIGHER_TITLE',
	SETTINGS_AUTO_ACCEPT_MODE_ACCEPT_ANY_TITLE = 'SPORTSBOOK_BETSLIP_SETTINGS_AUTO_ACCEPT_MODE_ACCEPT_ANY_TITLE',
	SHARE_BETSLIP_TITLE = 'SPORTSBOOK_BETSLIP_SHARE_BETSLIP_TITLE',
	SHARE_BETSLIP_SUBTITLE = 'SPORTSBOOK_BETSLIP_SHARE_BETSLIP_SUBTITLE',
	SHARE_BETSLIP_SHARE_BUTTON = 'SPORTSBOOK_BETSLIP_SHARE_BETSLIP_SHARE_BUTTON',
	SHARE_BETSLIP_SHARE_DIALOG_TITLE = 'SPORTSBOOK_BETSLIP_SHARE_BETSLIP_SHARE_DIALOG_TITLE',
	BET_BONUS_BOOST_TITLE = 'SPORTSBOOK_BETSLIP_BET_BONUS_BOOST_TITLE',
	SUPER_BOOST_TITLE = 'SPORTSBOOK_BETSLIP_SUPER_BOOST_TITLE',
	SYSTEM_BETS_OPTIONS = 'SPORTSBOOK_BETSLIP_SYSTEM_BETS_OPTIONS_TITLE',
	SYSTEM_BET_COUNT_LABEL = 'SPORTSBOOK_BETSLIP_SYSTEM_BET_COUNT_LABEL',
	PLACEMENT_SYSTEM_BET_LABEL = 'SPORTSBOOK_BETSLIP_PLACEMENT_SYSTEM_BET_LABEL',
	SKELETON_ODDS_UNAVAILABLE = 'SPORTSBOOK_BETSLIP_SKELETON_ODDS_UNAVAILABLE',
	LOCATION_NOT_SHARED_MESSAGE = 'SPORTSBOOK_BETSLIP_LOCATION_NOT_SHARED_MESSAGE',
	LOCATION_PENDING_MESSAGE = 'SPORTSBOOK_BETSLIP_LOCATION_PENDING_MESSAGE',
	LOCATION_DENIED_MESSAGE = 'SPORTSBOOK_BETSLIP_LOCATION_DENIED_MESSAGE',
	LOCATION_ERROR_MESSAGE = 'SPORTSBOOK_BETSLIP_LOCATION_ERROR_MESSAGE',
	FOOTER_ALLOW_LOCATION_SHARING_BUTTON_LABEL = 'SPORTSBOOK_BETSLIP_FOOTER_ALLOW_LOCATION_SHARING_BUTTON_LABEL',
	MAXIMUM_NUMBER_OF_BETSLIP_BETS_TITLE = 'SPORTSBOOK_NOTIFICATIONS_MAXIMUM_NUMBER_OF_BETSLIP_BETS_TITLE',
	BET_RECOMMENDATIONS_CAROUSEL_TITLE = 'SPORTSBOOK_BET_RECOMMENDATIONS_CAROUSEL_TITLE',
	FOOTER_SAVE_SETTINGS_LABEL = 'SPORTSBOOK_FOOTER_SAVE_SETTINGS_LABEL',
	REALITY_CHECK_LIMIT_EXCEEDED = 'SPORTSBOOK_REALITY_CHECK_LIMIT_EXCEEDED'
}
export const BETSLIP_TEXT_KEYS = Object.values({ ...BetslipTextKeys, ...SYSTEM_BET_COMBINATIONS_TEXT_KEYS });

export default BetslipTextKeys;
